// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import 'css/frontend'
import 'css/layout'
import 'css/invoices'
import 'css/messages'
import 'css/navbar'
import 'css/shared_components'
import 'css/icofont'
import 'css/admin/layout'
import 'css/variables'
import 'css/terms'

import 'aos'
import 'jquery'
import 'jquery-ui'
import 'jquery.easing'
import 'popper.js'
import 'bootstrap'
import 'boxicons'
import 'bootstrap-datepicker'
import "bootstrap-datepicker/dist/css/bootstrap-datepicker3.standalone.css"
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js"
import "summernote"
import "summernote/dist/summernote-bs4.css"
import 'spid-smart-button/dist/spid-button.min.js'
import 'spid-smart-button/dist/spid-button.min.css'

import 'css/application'
import "boxicons/css/boxicons.css"
import "aos/dist/aos.css"
import "@fortawesome/fontawesome-free/css/all"

import "packs/custom_js/main.js"
import "packs/custom_js/runtime.js"
import "packs/custom_js/spid.js"
import "packs/custom_js/aep"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require("trix")
require("@rails/actiontext")

import 'trix/dist/trix.css'
import 'css/actiontext'
import 'css/spid/css/spid-sp-access-button'
import 'css/spid/js/spid-sp-access-button.min'
import 'css/spid/css/spid_sp_access'